import { IconGhostWaveWall } from '@veneer/core';
import tokens from '@veneer/tokens';
import styled from 'styled-components';

export const ContentSectionNoSubscriptions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${tokens.typography.size9};
`;

export const IconGhost = styled(IconGhostWaveWall)`
  && {
    color: ${tokens.color.gray9};
  }
`;

export const NoSubscriptions = styled.span`
  color: ${tokens.color.gray9};
  font-size: ${tokens.typography.size2};
  line-height: ${tokens.typography.size5};
`;

export const HPStoreSubscriptionsInfo = styled.div`
  display: flex;
  flex: 1;

  p {
    font-size: ${tokens.typography.size2};
    font-weight: 400;
    height: ${tokens.typography.size5};
  }
`;

export const OffersSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.layout.size4};
`;

export const OffersHeading = styled.h3`
  font-family: ${tokens.typography.family0};
  font-weight: 400;
  font-size: ${tokens.typography.size1};
  margin: 0;
  line-height: ${tokens.layout.size5};
  letter-spacing: 0;
  color: ${tokens.color.gray9};
  display: flex;
  align-items: center;
`;
